import { makeQuery } from 'shared/utilities';

type ResponseType = {};

export const chatMessagesDeleteQuery = async function (id: number) {
    return await makeQuery<ResponseType>('/chat-messages/delete', { json: { id } });
}
